import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
	setExperienceDetails,
	setUserPosition,
} from '../services/store/experienceSlice'
import {
	getExperience,
	getExperiencePosition,
} from '../services/actions/experienceActions'

const ExperienceInitializer = () => {
	const dispatch = useDispatch()
	const { experienceSlug } = useParams()

	useEffect(() => {
		if (!experienceSlug) return

		const init = async () => {
			try {
				const experience = await getExperience(experienceSlug)
				dispatch(setExperienceDetails(experience))

				const position = await getExperiencePosition(experienceSlug)
				dispatch(setUserPosition(position))
			} catch (err) {
				console.error('❌ Failed to load experience context:', err)
			}
		}

		init()
	}, [dispatch, experienceSlug])

	return null
}

export default ExperienceInitializer
